// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   IconButton,
//   TextField,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Divider,
//   Typography,
//   Chip,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem
// } from "@mui/material";
// import Admin from "../Dashboard";
// import { RobotoTypo } from "../../../utils/Typographies";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import { Category, Clear } from "@mui/icons-material";
// import { makeStyles } from "@mui/styles";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { contactFormStyles } from "../../../components/ContactUs/ContactForm";
// import moment from "moment";
// import { DesktopDatePicker } from "@mui/x-date-pickers";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
// import { useSelector } from "react-redux";

// export default function AddConsultation() {

//     const languages = useSelector((state) => state.language.languageList);

//     const [loading, setLoading] = useState(false);
//     const [data, setData] = useState({
//   category: "",
//   title: {},
//   description: {},
//   tags: {},
//   leaveDates: [],
//   timeSlots: [],
//   videoUrls: [],

//   existingImages: [],   // from DB
//   newImages: [],        // File objects
//   deletedImages: [],    // filenames removed in edit

//   images: [],           // UI-only merged list (existing + new)
// });

//     const { id } = useParams();
//     console.log("id ", id);
//     const navigate = useNavigate();

//     useEffect(() => {
//   if (!id) return;

//   const fetchConsultation = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-consultation/${id}`);
//       const consult = res.data.data;

//       setData(prev => ({
//         ...prev,
//         category: consult.category || "",
//         title: consult.title || {},
//         description: consult.description || {},
//         tags: consult.tags || {},
//         leaveDates: consult.leaveDates || [],
//         timeSlots: consult.timeSlots || [],
//         videoUrls: consult.videoUrls || [],

//         existingImages: consult.images || [],        // DB images
//         newImages: [],                               // fresh start
//         deletedImages: [],
//         images: consult.images || [],                // UI view
//       }));
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   fetchConsultation();
// }, [id]);

//     console.log("data ", data);

//     const category = [
//         {
//             id : 1,
//             name : "Online Consultation",
//             key : "online-consultation"
//         },
//         {
//             id : 2,
//             name : "School Based Tour",
//             key : "school-based-tour"
//         },
//         {
//             id : 3,
//             name : "Offline Consultation",
//             key : "offline-consultation"
//         },
//         {
//             id : 4,
//             name : "Online Info Session",
//             key : "online-info-session"
//         },
//         {
//             id : 5,
//             name : "Offline Info Session",
//             key : "offline-info-session"
//         }
//     ]


//     useEffect(() => {
//   const today = new Date().setHours(0, 0, 0, 0);

//   const filtered = data.leaveDates.filter((d) => {
//     const dt = new Date(d).setHours(0, 0, 0, 0);
//     return dt >= today;
//   });

//   if (filtered.length !== data.leaveDates.length) {
//     setData({ ...data, leaveDates: filtered });
//   }
// }, [data.leaveDates]);


// const getImageUrl = (img) => {
//   // If it's a File object
//   if (img instanceof File) {
//     return URL.createObjectURL(img);
//   }

//   // If it's a saved object from DB
//   if (img?.filePath) {
//     return `${process.env.REACT_APP_FILE_URL1}${img.filePath}`;
//   }

//   return "";
// };


// const handleSubmit = async () => {
//   const formData = new FormData();

//   formData.append(
//     "data",
//     JSON.stringify({
//       ...data,
//       existingImages: data.existingImages,
//       deletedImages: data.deletedImages,
//       imagesMeta: Object.fromEntries(
//         data.newImages.map(f => [f.name, { lastModified: f.lastModified }])
//       ),
//     })
//   );

//   data.newImages.forEach(file => formData.append("images", file));

//   const url = id
//     ? `${process.env.REACT_APP_BASE_URL}/update-consultation/${id}`
//     : `${process.env.REACT_APP_BASE_URL}/add-consultation`;

//   const method = id ? "put" : "post";

//   try {
//     setLoading(true);
//     const res = await axios({
//       method,
//       url,
//       data: formData,
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: localStorage.getItem("admin_token"),
//       },
//     });

//     if (res.status === 200 || res.status === 201) {
//       navigate("/admin/consultation");
//     }
//   } finally {
//     setLoading(false);
//   }
// };


  

//   return (
//     <Admin>

//       <FormControl fullWidth sx={{ mt: 2 }}>
//   <InputLabel>Select Category</InputLabel>
//   <Select
//     value={data.category || ""}
//     displayEmpty
//     onChange={(e) =>
//       setData({ ...data, category: e.target.value })
//     }
//   >
//     {category.map((cat, index) => (
//       <MenuItem key={index} value={cat.key}>
//         {cat.name}
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>

//       <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", mt : 4 }}>
//         {languages.map((lang) => (
//             <>
//           <Box key={lang.code}>
//             <RobotoTypo variant="h6">{lang.label}</RobotoTypo>
//           </Box>
//           <Box>
//             <TextField
//               fullWidth
//               placeholder={`Title (${lang.label})`}
//               value={data.title[lang.code] || ""}
//               onChange={(e) =>
//                 setData({
//                   ...data,
//                   title: { ...data.title, [lang.code]: e.target.value },
//                 })
//               }
//             />
//             <TextField
//             sx={{marginTop : '20px'}}
//               fullWidth
//               rows={4}
//               multiline
//               placeholder={`Description (${lang.label})`}
//               value={data.description[lang.code] || ""}
//               onChange={(e) =>
//                 setData({
//                   ...data,
//                   description: { ...data.description, [lang.code]: e.target.value },
//                 })
//               }
//             />
//           </Box>
//           </>
//         ))}

//         <Box sx={{mt : 4}}>
//             {languages.map((lang) => (
//   <Box key={lang.code} sx={{ mb: 2 }}>
//     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//       Tags ({lang.label})
//     </Typography>

//     {/* Tag List */}
//     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//       {(data.tags[lang.code] || []).map((tag, index) => (
//         <Chip
//           key={index}
//           label={tag}
//           onDelete={() => {
//             const updated = [...data.tags[lang.code]];
//             updated.splice(index, 1);
//             setData({ ...data, tags: { ...data.tags, [lang.code]: updated } });
//           }}
//           onClick={() => {
//             // Allow editing the tag
//             const newValue = prompt("Edit tag:", tag);
//             if (newValue && newValue.trim() !== "") {
//               const updated = [...data.tags[lang.code]];
//               updated[index] = newValue.trim();
//               setData({ ...data, tags: { ...data.tags, [lang.code]: updated } });
//             }
//           }}
//         />
//       ))}
//     </Box>

//     {/* Input + Add Button */}
//     <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
//       <TextField
//         fullWidth
//         placeholder={`Add tag (${lang.label})`}
//         value={data.tempTag?.[lang.code] || ""}
//         onChange={(e) =>
//           setData({
//             ...data,
//             tempTag: { ...data.tempTag, [lang.code]: e.target.value },
//           })
//         }
//       />

//       <Button
//         variant="contained"
//         onClick={() => {
//           const newTag = data.tempTag?.[lang.code]?.trim();
//           if (!newTag) return;

//           const existing = data.tags[lang.code] || [];
//           const updated = [...existing, newTag];

//           setData({
//             ...data,
//             tags: { ...data.tags, [lang.code]: updated },
//             tempTag: { ...data.tempTag, [lang.code]: "" }, // clear input
//           });
//         }}
//       >
//         Add
//       </Button>
//     </Box>
//   </Box>
// ))}
//         </Box>

//         <Box>
//   <Button variant="contained" component="label" sx={{ mt: 2 }}>
//     Upload Images
//     <input
//   type="file"
//   hidden
//   multiple
//   onChange={(e) => {
//     const files = Array.from(e.target.files);

//     setData(prev => ({
//       ...prev,
//       newImages: [...prev.newImages, ...files],
//       images: [...prev.images, ...files],   // UI update
//     }));
//   }}
// />
//   </Button>

//   <Box
//     sx={{
//       display: "flex",
//       gap: 2,
//       mt: 2,
//       flexWrap: "wrap",
//     }}
//   >
//     {data.images.map((img, index) => (
//       <Box key={index} sx={{ position: "relative", width: 100, height: 100 }}>
        
//         {/* Image Preview */}
//         <img
//           src={getImageUrl(img)}
//           alt={`Preview ${index}`}
//           style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 4 }}
//         />

//         {/* Delete Button */}
//         <IconButton
//           size="small"
//           onClick={() => {
//   const img = data.images[index];

//   // If existing image, mark it as deleted
//   if (img.fileName) {
//     setData(prev => ({
//       ...prev,
//       deletedImages: [...prev.deletedImages, img.fileName],
//       existingImages: prev.existingImages.filter(i => i.fileName !== img.fileName),
//       images: prev.images.filter((_, i) => i !== index),
//     }));
//   } 
//   else {
//     // It is a new image (File)
//     setData(prev => ({
//       ...prev,
//       newImages: prev.newImages.filter(f => f !== img),
//       images: prev.images.filter((_, i) => i !== index),
//     }));
//   }
// }}
//           sx={{
//             position: "absolute",
//             top: 2,
//             right: 2,
//             bgcolor: "rgba(0,0,0,0.5)",
//             color: "#fff",
//             "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
//           }}
//         >
//           <DeleteIcon fontSize="small" />
//         </IconButton>
//       </Box>
//     ))}
//   </Box>
// </Box>

// <Box>
//   <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
//     Video URLs
//   </RobotoTypo>

//   {data.videoUrls.map((url, index) => (
//     <Box
//       key={index}
//       sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
//     >
//       <TextField
//         fullWidth
//         placeholder="Video URL"
//         value={url}
//         onChange={(e) => {
//           const updated = [...data.videoUrls];
//           updated[index] = e.target.value; // replace the value
//           setData({ ...data, videoUrls: updated });
//         }}
//       />

//       {/* Delete Button */}
//       <IconButton
//         size="small"
//         onClick={() => {
//           const updated = [...data.videoUrls];
//           updated.splice(index, 1);
//           setData({ ...data, videoUrls: updated });
//         }}
//         sx={{
//           bgcolor: "rgba(0,0,0,0.5)",
//           color: "#fff",
//           "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
//         }}
//       >
//         <DeleteIcon fontSize="small" />
//       </IconButton>
//     </Box>
//   ))}

//   {/* Add New URL */}
//   <Button
//     variant="outlined"
//     sx={{ mt: 1 }}
//     onClick={() =>
//       setData((prev) => ({
//         ...prev,
//         videoUrls: [...prev.videoUrls, ""], // new empty field
//       }))
//     }
//   >
//     + Add Video URL
//   </Button>
// </Box>

// <Box>
//   <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
//     Leave Dates
//   </RobotoTypo>

//   {/* Input + Add Button */}
//   <Box sx={{ display: "flex", gap: 2 }}>
//     <TextField
//       type="date"
//       fullWidth
//       value={data.leaveDate || ""}  // store temp input only
//       minDate={new Date().toISOString().split("T")[0]} // disable past dates
//       onChange={(e) => {
//         const selected = e.target.value;
//         const today = new Date().setHours(0, 0, 0, 0);
//         const selectedDate = new Date(selected).setHours(0, 0, 0, 0);

//         // Prevent past dates
//         if (selectedDate < today) {
//           alert("Please choose a future date");
//           return;
//         }

//         setData({ ...data, leaveDate: selected }); // store selected temporarily
//       }}
//     />

//     <Button
//       variant="contained"
//       onClick={() => {
//         const date = data.leaveDate;
//         if (!date) return;

//         // Prevent duplicates
//         if (data.leaveDates.includes(date)) {
//           alert("Date already added");
//           return;
//         }

//         // Add date
//         setData({
//           ...data,
//           leaveDates: [...data.leaveDates, date],
//           leaveDate: "", // clear input
//         });
//       }}
//     >
//       Add
//     </Button>
//   </Box>

//   {/* Leave Dates List */}
//   <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
//     {data.leaveDates.map((date, index) => (
//       <Chip
//         key={index}
//         label={moment(date).format("DD/MM/YYYY")}
//         onDelete={() => {
//           const updated = [...data.leaveDates];
//           updated.splice(index, 1);
//           setData({ ...data, leaveDates: updated });
//         }}
//         color="primary"
//       />
//     ))}
//   </Box>
// </Box>

// <Box>
//   <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
//     Time Slots
//   </RobotoTypo>

//   {/* Input + Add Button */}
//   <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//     <TextField
//       fullWidth
//       placeholder="Enter Time Slot (e.g., 12 - 1)"
//       value={data.tempTimeSlot || ""}
//       onChange={(e) =>
//         setData({ ...data, tempTimeSlot: e.target.value })
//       }
//     />

//     <Button
//       variant="contained"
//       onClick={() => {
//         const slot = data.tempTimeSlot?.trim();
//         if (!slot) return;

//         // Prevent duplicates
//         if (data.timeSlots.includes(slot)) {
//           alert("This time slot already exists");
//           return;
//         }

//         setData({
//           ...data,
//           timeSlots: [...data.timeSlots, slot],
//           tempTimeSlot: "", // clear input
//         });
//       }}
//     >
//       Add
//     </Button>
//   </Box>

//   {/* Time Slot List */}
//   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//     {data.timeSlots.map((slot, index) => (
//       <Chip
//         key={index}
//         label={slot}
//         onClick={() => {
//           const updated = prompt("Edit time slot:", slot);
//           if (updated && updated.trim() !== "") {
//             const slotsCopy = [...data.timeSlots];
//             slotsCopy[index] = updated.trim();
//             setData({ ...data, timeSlots: slotsCopy });
//           }
//         }}
//         onDelete={() => {
//           const updated = [...data.timeSlots];
//           updated.splice(index, 1);
//           setData({ ...data, timeSlots: updated });
//         }}
//         color="primary"
//       />
//     ))}
//   </Box>
// </Box>

        


//         <Box>
//           <Button disabled={loading} onClick={handleSubmit} variant="contained" color="primary">
//             {id ? "Update Consultation" : "Add Consultation"}
//           </Button>
//         </Box>
//       </Box>
//     </Admin>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Snackbar,
  Card,
  CardContent
} from "@mui/material";
import Admin from "../Dashboard";
import { RobotoTypo } from "../../../utils/Typographies";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import moment from "moment";
import ToastAlert from "../../../utils/Alert";

export default function AddConsultation() {
  const languages = useSelector((state) => state.language.languageList);
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showValidationError, setShowValidationError] = useState(false);
  const [step, setStep] = useState(1); // 1: Select category, 2: Fill details
  
  const [data, setData] = useState({
    category: "",
    title: {},
    description: {},
    tags: {},
    leaveDates: [],
    timeSlots: [],
    videoUrls: [],
    existingImages: [],
    newImages: [],
    deletedImages: [],
    images: [],
    bannerImage: null,
    existingBannerImage: null,
    bannerImageDeleted: false,
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;

    const fetchConsultation = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-consultation/${id}`);
        const consult = res.data.data;

        setData(prev => ({
          ...prev,
          category: consult.category || "",
          title: consult.title || {},
          description: consult.description || {},
          tags: consult.tags || {},
          leaveDates: consult.leaveDates || [],
          timeSlots: consult.timeSlots || [],
          videoUrls: consult.videoUrls || [],
          existingImages: consult.images || [],
          newImages: [],
          deletedImages: [],
          images: consult.images || [],
          existingBannerImage: consult.bannerImage || null,
          bannerImage: consult.bannerImage || null,
        }));
        
        // If editing and category already selected, go to step 2
        if (consult.category) {
          setStep(2);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchConsultation();
  }, [id]);

  const category = [
    {
      id: 1,
      name: "Online Consultation",
      key: "online-consultation",
      requiresLeaveDates: true,
      requiresTimeSlots: true
    },
    {
      id: 2,
      name: "School Based Tour",
      key: "school-based-tour",
      requiresLeaveDates: false,
      requiresTimeSlots: false
    },
    {
      id: 3,
      name: "Offline Consultation",
      key: "offline-consultation",
      requiresLeaveDates: true,
      requiresTimeSlots: true
    },
    {
      id: 4,
      name: "Online Info Session",
      key: "online-info-session",
      requiresLeaveDates: false,
      requiresTimeSlots: false
    },
    {
      id: 5,
      name: "Offline Info Session",
      key: "offline-info-session",
      requiresLeaveDates: false,
      requiresTimeSlots: false
    }
  ];

  const getCurrentCategoryConfig = () => {
    return category.find(cat => cat.key === data.category);
  };

  const noLeaveDatesCategories = ["school-based-tour", "online-info-session", "offline-info-session"];
  const needsLeaveAndTime = !noLeaveDatesCategories.includes(data.category);

  useEffect(() => {
    const today = new Date().setHours(0, 0, 0, 0);
    const filtered = data.leaveDates.filter((d) => {
      const dt = new Date(d).setHours(0, 0, 0, 0);
      return dt >= today;
    });

    if (filtered.length !== data.leaveDates.length) {
      setData({ ...data, leaveDates: filtered });
    }
  }, [data.leaveDates]);

  const getImageUrl = (img) => {
    if (img instanceof File) {
      return URL.createObjectURL(img);
    }
    
    if (img?.filePath) {
      return `${process.env.REACT_APP_FILE_URL1}${img.filePath}`;
    }
    
    if (typeof img === 'string') {
      return img;
    }
    
    return "";
  };

  const getBannerImageUrl = () => {
    if (data.bannerImage instanceof File) {
      return URL.createObjectURL(data.bannerImage);
    }
    
    if (data.existingBannerImage?.filePath) {
      return `${process.env.REACT_APP_FILE_URL1}${data.existingBannerImage.filePath}`;
    }
    
    if (typeof data.bannerImage === 'string') {
      return data.bannerImage;
    }
    
    return "";
  };

  const handleCategorySelect = () => {
    if (!data.category) {
      setErrors({ category: "Please select a category" });
      return;
    }
    setErrors({});
    setStep(2);
  };

  const clearError = (fieldName) => {
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Validate category
    if (!data.category) {
      newErrors.category = "Category is required";
      isValid = false;
    }

    // Validate title and description for each language
    languages.forEach(lang => {
      if (!data.title[lang.code] || data.title[lang.code].trim() === "") {
        newErrors[`title_${lang.code}`] = `Title (${lang.label}) is required`;
        isValid = false;
      }
      
      if (!data.description[lang.code] || data.description[lang.code].trim() === "") {
        newErrors[`description_${lang.code}`] = `Description (${lang.label}) is required`;
        isValid = false;
      }
    });

    // Validate leave dates and time slots for categories that need them
    const categoryConfig = getCurrentCategoryConfig();
    // if (categoryConfig?.requiresLeaveDates && (!data.leaveDates || data.leaveDates.length === 0)) {
    //   newErrors.leaveDates = "At least one leave date is required";
    //   isValid = false;
    // }

    if (categoryConfig?.requiresTimeSlots && (!data.timeSlots || data.timeSlots.length === 0)) {
      newErrors.timeSlots = "At least one time slot is required";
      isValid = false;
    }

    data.videoUrls.forEach((url, index) => {
      if (url.trim() === "") {
        newErrors[`videoUrl_${index}`] = "Video URL cannot be empty";
        isValid = false;
      }

    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setShowValidationError(true);
      return;
    }

    const formData = new FormData();

    formData.append(
      "data",
      JSON.stringify({
        ...data,
        existingImages: data.existingImages,
        deletedImages: data.deletedImages,
        imagesMeta: Object.fromEntries(
          data.newImages.map(f => [f.name, { lastModified: f.lastModified }])
        ),
        existingBannerImage: data.existingBannerImage,
        bannerImageDeleted: data.bannerImageDeleted,
      })
    );

    data.newImages.forEach(file => formData.append("images", file));
    
    if (data.bannerImage instanceof File) {
      formData.append("bannerImage", data.bannerImage);
    }

    const url = id
      ? `${process.env.REACT_APP_BASE_URL}/update-consultation/${id}`
      : `${process.env.REACT_APP_BASE_URL}/add-consultation`;

    const method = id ? "put" : "post";

    try {
      setLoading(true);
      const res = await axios({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("admin_token"),
        },
      });

      if (res.status === 200 || res.status === 201) {
        setTimeout(() => {
          navigate("/admin/consultation");
        }, 1000);
        
        ToastAlert({ type: 'success', message: `Consultation ${id ? 'updated' : 'created'} successfully!` });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  const tagExists = (langCode, tagValue) => {
    const tagsForLang = data.tags[langCode] || [];
    return tagsForLang.some(tag => tag.toLowerCase() === tagValue.toLowerCase());
  };

  const isLastUrlEmpty =
  data.videoUrls.length > 0 &&
  !data.videoUrls[data.videoUrls.length - 1]?.trim();

  // Render step 1: Category selection
  const renderCategorySelection = () => (
    <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Select Consultation Type
        </Typography>
        <Typography color="textSecondary" paragraph>
          Choose the type of consultation you want to create
        </Typography>
        
        <FormControl fullWidth sx={{ mt: 3 }} error={!!errors.category}>
          <InputLabel>Select Category*</InputLabel>
          <Select
            value={data.category || ""}
            onChange={(e) => {
              setData({ ...data, category: e.target.value });
              clearError('category');
            }}
            label="Select Category*"
          >
            {category.map((cat, index) => (
              <MenuItem key={index} value={cat.key}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
          {errors.category && (
            <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
              {errors.category}
            </Typography>
          )}
        </FormControl>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
          <Button 
            variant="outlined" 
            onClick={() => navigate("/admin/consultation")}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleCategorySelect}
          >
            Next: Fill Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );

  // Render step 2: Form details
  const renderFormDetails = () => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5">
          {id ? "Edit Consultation" : "Create Consultation"}
        </Typography>
        <Button 
          variant="outlined" 
          onClick={() => setStep(1)}
          size="small"
        >
          Change Category
        </Button>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <Chip 
          label={category.find(c => c.key === data.category)?.name || "No category selected"} 
          color="primary"
          sx={{ fontWeight: 'bold' }}
        />
      </Box>

      <Snackbar
        open={showValidationError}
        autoHideDuration={6000}
        onClose={() => setShowValidationError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setShowValidationError(false)}>
          Please fill in all required fields correctly.
        </Alert>
      </Snackbar>

      {/* Banner Image */}
      <Box>
        <RobotoTypo variant="h6" sx={{ mb: 2 }}>
          Banner Image
        </RobotoTypo>
        
        {getBannerImageUrl() ? (
          <Box sx={{ position: 'relative', mb: 2 }}>
            <img
              src={getBannerImageUrl()}
              alt="Banner"
              style={{ 
                width: '100%', 
                height: '200px', 
                objectFit: 'cover', 
                borderRadius: 8 
              }}
            />
            <IconButton
              size="small"
              onClick={() => {
                if (data.existingBannerImage) {
                  setData(prev => ({
                    ...prev,
                    bannerImage: null,
                    existingBannerImage: null,
                    bannerImageDeleted: true
                  }));
                } else {
                  setData(prev => ({
                    ...prev,
                    bannerImage: null
                  }));
                }
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : null}
        
        <Button variant="contained" component="label">
          {getBannerImageUrl() ? "Change Banner Image" : "Upload Banner Image"}
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setData(prev => ({
                  ...prev,
                  bannerImage: file,
                  bannerImageDeleted: false
                }));
              }
            }}
          />
        </Button>
      </Box>

      {languages.map((lang) => (
        <React.Fragment key={lang.code}>
          <Box>
            <RobotoTypo variant="h6">{lang.label}</RobotoTypo>
          </Box>
          <Box>
            <TextField
              fullWidth
              placeholder={`Title (${lang.label})*`}
              value={data.title[lang.code] || ""}
              onChange={(e) => {
                setData({
                  ...data,
                  title: { ...data.title, [lang.code]: e.target.value },
                });
                clearError(`title_${lang.code}`);
              }}
              error={!!errors[`title_${lang.code}`]}
              helperText={errors[`title_${lang.code}`]}
            />
            <TextField
              sx={{ marginTop: '20px' }}
              fullWidth
              rows={4}
              multiline
              placeholder={`Description (${lang.label})*`}
              value={data.description[lang.code] || ""}
              onChange={(e) => {
                setData({
                  ...data,
                  description: { ...data.description, [lang.code]: e.target.value },
                });
                clearError(`description_${lang.code}`);
              }}
              error={!!errors[`description_${lang.code}`]}
              helperText={errors[`description_${lang.code}`]}
            />
          </Box>
        </React.Fragment>
      ))}

      <Box sx={{ mt: 4 }}>
        {languages.map((lang) => (
          <Box key={lang.code} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Tags ({lang.label})
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
              {(data.tags[lang.code] || []).map((tag, index) => (
                <Chip
                  key={index}
                  label={tag}
                  onDelete={() => {
                    const updated = [...data.tags[lang.code]];
                    updated.splice(index, 1);
                    setData({ ...data, tags: { ...data.tags, [lang.code]: updated } });
                  }}
                  onClick={() => {
                    const newValue = prompt("Edit tag:", tag);
                    if (newValue && newValue.trim() !== "") {
                      const tagExists = (data.tags[lang.code] || []).some(
                        (existingTag, idx) => 
                          idx !== index && existingTag.toLowerCase() === newValue.toLowerCase()
                      );
                      
                      if (tagExists) {
                        alert("This tag already exists");
                        return;
                      }
                      
                      const updated = [...data.tags[lang.code]];
                      updated[index] = newValue.trim();
                      setData({ ...data, tags: { ...data.tags, [lang.code]: updated } });
                    }
                  }}
                />
              ))}
            </Box>

            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              <TextField
                fullWidth
                placeholder={`Add tag (${lang.label})`}
                value={data.tempTag?.[lang.code] || ""}
                onChange={(e) =>
                  setData({
                    ...data,
                    tempTag: { ...data.tempTag, [lang.code]: e.target.value },
                  })
                }
              />

              <Button
                variant="contained"
                onClick={() => {
                  const newTag = data.tempTag?.[lang.code]?.trim();
                  if (!newTag) return;

                  if (tagExists(lang.code, newTag)) {
                    alert("This tag already exists");
                    return;
                  }

                  const existing = data.tags[lang.code] || [];
                  const updated = [...existing, newTag];

                  setData({
                    ...data,
                    tags: { ...data.tags, [lang.code]: updated },
                    tempTag: { ...data.tempTag, [lang.code]: "" },
                  });
                }}
              >
                Add
              </Button>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Regular Images */}
      <Box>
        <RobotoTypo variant="h6" sx={{ mb: 2 }}>
          Additional Images
        </RobotoTypo>
        
        <Button variant="contained" component="label" sx={{ mb: 2 }}>
          Upload Images
          <input
            type="file"
            hidden
            multiple
            accept="image/*"
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setData(prev => ({
                ...prev,
                newImages: [...prev.newImages, ...files],
                images: [...prev.images, ...files],
              }));
            }}
          />
        </Button>

        <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
          {data.images.map((img, index) => (
            <Box key={index} sx={{ position: "relative", width: 100, height: 100 }}>
              <img
                src={getImageUrl(img)}
                alt={`Preview ${index}`}
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 4 }}
              />
              <IconButton
                size="small"
                onClick={() => {
                  const img = data.images[index];
                  if (img.fileName) {
                    setData(prev => ({
                      ...prev,
                      deletedImages: [...prev.deletedImages, img.fileName],
                      existingImages: prev.existingImages.filter(i => i.fileName !== img.fileName),
                      images: prev.images.filter((_, i) => i !== index),
                    }));
                  } else {
                    setData(prev => ({
                      ...prev,
                      newImages: prev.newImages.filter(f => f !== img),
                      images: prev.images.filter((_, i) => i !== index),
                    }));
                  }
                }}
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  bgcolor: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Video URLs */}
      <Box>
        <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
          Video URLs
        </RobotoTypo>

        

        {data.videoUrls.map((url, index) => (
          <>
          <Box
            key={index}
            sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
          >
            <TextField
  fullWidth
  placeholder="Video URL"
  value={url}
  error={!url?.trim()}
  // helperText={!url?.trim() ? "Video URL cannot be empty" : ""}
  onChange={(e) => {
    const value = e.target.value;
    const updated = [...data.videoUrls];
    updated[index] = value;
    setData({ ...data, videoUrls: updated });
  }}
/>

            <IconButton
              size="small"
              onClick={() => {
                const updated = [...data.videoUrls];
                updated.splice(index, 1);
                setData({ ...data, videoUrls: updated });
              }}
              sx={{
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box>
          
          {errors[`videoUrl_${index}`] && (
  <Typography
    color="error"
    variant="caption"
    sx={{ mt: 1, display: "block" }}
  >
    {errors[`videoUrl_${index}`]}
  </Typography>
)}
          </Box>
          </>
        ))}

       

        <Button
  variant="outlined"
  sx={{ mt: 1 }}
  disabled={isLastUrlEmpty}
  onClick={() =>
    setData((prev) => ({
      ...prev,
      videoUrls: [...prev.videoUrls, ""],
    }))
  }
>
  + Add Video URL
</Button>
      </Box>

      {/* Conditional Leave Dates and Time Slots */}
      {needsLeaveAndTime && (
        <>
          <Box>
            <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
              Leave Dates*
            </RobotoTypo>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                type="date"
                fullWidth
                value={data.leaveDate || ""}
                minDate={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  const selected = e.target.value;
                  const today = new Date().setHours(0, 0, 0, 0);
                  const selectedDate = new Date(selected).setHours(0, 0, 0, 0);

                  if (selectedDate < today) {
                    alert("Please choose a future date");
                    return;
                  }

                  setData({ ...data, leaveDate: selected });
                  clearError('leaveDates');
                }}
              />

              <Button
                variant="contained"
                onClick={() => {
                  const date = data.leaveDate;
                  if (!date) return;

                  if (data.leaveDates.includes(date)) {
                    alert("Date already added");
                    return;
                  }

                  setData({
                    ...data,
                    leaveDates: [...data.leaveDates, date],
                    leaveDate: "",
                  });
                  clearError('leaveDates');
                }}
              >
                Add
              </Button>
            </Box>

            <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
              {data.leaveDates.map((date, index) => (
                <Chip
                  key={index}
                  label={moment(date).format("DD/MM/YYYY")}
                  onDelete={() => {
                    const updated = [...data.leaveDates];
                    updated.splice(index, 1);
                    setData({ ...data, leaveDates: updated });
                    clearError('leaveDates');
                  }}
                  color="primary"
                />
              ))}
            </Box>
            {errors.leaveDates && (
              <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                {errors.leaveDates}
              </Typography>
            )}
          </Box>

          <Box>
            <RobotoTypo variant="h6" sx={{ mt: 4, mb: 2 }}>
              Time Slots*
            </RobotoTypo>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                fullWidth
                placeholder="Enter Time Slot (e.g., 12 - 1)*"
                value={data.tempTimeSlot || ""}
                onChange={(e) => {
                  setData({ ...data, tempTimeSlot: e.target.value });
                  clearError('timeSlots');
                }}
              />

              <Button
                variant="contained"
                onClick={() => {
                  const slot = data.tempTimeSlot?.trim();
                  if (!slot) return;

                  if (data.timeSlots.includes(slot)) {
                    alert("This time slot already exists");
                    return;
                  }

                  setData({
                    ...data,
                    timeSlots: [...data.timeSlots, slot],
                    tempTimeSlot: "",
                  });
                  clearError('timeSlots');
                }}
              >
                Add
              </Button>
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {data.timeSlots.map((slot, index) => (
                <Chip
                  key={index}
                  label={slot}
                  onClick={() => {
                    const updated = prompt("Edit time slot:", slot);
                    if (updated && updated.trim() !== "") {
                      const slotExists = data.timeSlots.some(
                        (existingSlot, idx) => 
                          idx !== index && existingSlot.toLowerCase() === updated.trim().toLowerCase()
                      );
                      
                      if (slotExists) {
                        alert("This time slot already exists");
                        return;
                      }
                      
                      const slotsCopy = [...data.timeSlots];
                      slotsCopy[index] = updated.trim();
                      setData({ ...data, timeSlots: slotsCopy });
                    }
                  }}
                  onDelete={() => {
                    const updated = [...data.timeSlots];
                    updated.splice(index, 1);
                    setData({ ...data, timeSlots: updated });
                    clearError('timeSlots');
                  }}
                  color="primary"
                />
              ))}
            </Box>
            {errors.timeSlots && (
              <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                {errors.timeSlots}
              </Typography>
            )}
          </Box>
        </>
      )}

      <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
        <Button 
          variant="outlined" 
          onClick={() => navigate("/admin/consultation")}
        >
          Cancel
        </Button>
        <Button 
          disabled={loading} 
          onClick={handleSubmit} 
          variant="contained" 
          color="primary"
        >
          {id ? "Update Consultation" : "Add Consultation"}
        </Button>
      </Box>
    </Box>
  );

  return (
    <Admin>
      {step === 1 ? renderCategorySelection() : renderFormDetails()}
    </Admin>
  );
}